import React from "react";
import {
  ContentHubCategoryBase,
  Title,
  Description,
  Link,
  Posts,
  SmallPostContainer,
} from "./content-hub-category.styled";
import { PostsByCategory } from "../../templates/content-hub/content-hub";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import SmallPostCard from "../small-post-card/small-post-card";
import { linkTo } from "../../utils/contentUtils";

interface IContentHubCategoryProps {
  contentHubCategory: PostsByCategory;
}

const ContentHubCategory = (props: IContentHubCategoryProps) => {
  const categoryData = props.contentHubCategory.categoryData?.data;
  const category = props.contentHubCategory.categoryData;
  const posts = props.contentHubCategory.posts;

  return (
    <ContentHubCategoryBase>
      {categoryData?.category_title && (
        <Title>{categoryData.category_title}</Title>
      )}
      {category && categoryData?.category_title && (
        <Link href={linkTo(category)}>
          {`View All ${categoryData.category_title} Content`}
        </Link>
      )}
      {categoryData?.description && (
        <Description>
          <PrismicRichText
            field={categoryData.description.richText}
            components={htmlSerializer}
          />
        </Description>
      )}
      <Posts>
        {posts &&
          posts.map(({ node }, index) => (
            <SmallPostContainer key={index}>
              <SmallPostCard post={node} />
            </SmallPostContainer>
          ))}
      </Posts>
    </ContentHubCategoryBase>
  );
};

export default ContentHubCategory;
